import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const ItemMenu = ({ anchorEl, handleClose, handleRename, handleNewItem, newItem = false, handleDelete }) => {
    const open = Boolean(anchorEl);
    return (
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
                'aria-labelledby': 'basic-button'
            }}
        >
            <MenuItem onClick={handleRename}>Rename</MenuItem>
            {newItem && <MenuItem onClick={handleNewItem}>New Item</MenuItem>}
            <MenuItem onClick={handleDelete}>Delete</MenuItem>
        </Menu>
    );
};

export default ItemMenu;
